import * as React from "react";
import styled from "styled-components";
import { IconButton, Tooltip } from "@mui/material";
import { CloudDownloadOutlined, EditOutlined } from "@mui/icons-material";
import moment from "moment";
import { navigate } from "@reach/router";
import { GetReportsBasedOnParams_reportsWithParams } from "./__generated__/GetReportsBasedOnParams";

interface Props {
    item: GetReportsBasedOnParams_reportsWithParams;
}

const Wrapper = styled.div`
    border: 1px solid ${(props) => props.theme.lightGrayBottom};
    border-radius: 8px;
    margin: 5px 0px;
    padding: 10px 18px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const DownloadReport = styled.a`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    padding: 6px 16px;
    border-radius: 4px;
    background-color: #e7f7eb;
    color: #627567;
    cursor: pointer;
    text-decoration: none;
    font-weight: 600;
    &:hover {
        background-color: #dcf3e2;
    }
`;

const Info = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 180px;
`;

const Title = styled.div`
    font-weight: bold;
    margin-bottom: 2px;
    font-size: 14px;
`;

const Description = styled.div`
    color: ${(props) => props.theme.gray};
    font-size: 12px;
`;

const InfoAndChannels = styled.div`
    display: flex;
    flex-direction: row;
    @media (max-width: 500px) {
        flex-direction: column;
    }
`;

export default function ReportOverviewItem({ item }: Props) {
    const { clientId, end, name, reportId, organizationId, start, reportGenerated } = item;

    return (
        <Wrapper>
            <InfoAndChannels>
                <Info>
                    <Title>{name}</Title>
                    {clientId && <Description>ClientID: {clientId}</Description>}
                    <Description>
                        {moment(start).format("MMM DD, HH:mm")} - {end ? moment(end).format("MMM DD, HH:mm") : "..."}
                    </Description>
                </Info>
            </InfoAndChannels>
            <div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    {reportGenerated && (
                        <DownloadReport
                            href={`https://reporting.theo.live/reports/${organizationId}/${reportId}.json`}
                            target="_blank"
                        >
                            Report ready <CloudDownloadOutlined style={{ fontSize: "18px" }} />
                        </DownloadReport>
                    )}
                    {!reportGenerated && (
                        <Tooltip title="edit">
                            <IconButton
                                onClick={() => navigate(`/app/${organizationId}/reporting/${reportId}/edit`)}
                                size="small"
                            >
                                <EditOutlined fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                </div>
            </div>
        </Wrapper>
    );
}
